import { Injectable } from '@angular/core';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HourlySalesReportService {

  


  constructor(private http: HttpClient) { }
    // getWeekDefNoList(): Observable<any> {
    //   return this.http.get(environment.baseUrl+'/hq/week-def/get');
  
    // }
    exportHourlySalesReport(data:any): Observable<any> {
      return this.http.post(
        environment.baseUrl+'/shop/reports/hourly-sales-report', 
        data, 
        { responseType: 'blob' }
  );
    }
}
